import { renderSlot as _renderSlot, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_KeepAlive, null, [
    _renderSlot(_ctx.$slots, "default")
  ], 1024))
}